import { render } from "./excursionCreate.vue?vue&type=template&id=13c7a426"
import script from "./excursionCreate.vue?vue&type=script&lang=js"
export * from "./excursionCreate.vue?vue&type=script&lang=js"

import "./excursionCreate.vue?vue&type=style&index=0&id=13c7a426&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__